export enum SnackbarSize {
  SM = 'sm',
  RG = 'rg',
}

export enum SnackbarType {
  Notification = 'notification',
  Error = 'error',
  Warning = 'warning',
  Success = 'success',
}
